import { AxiosResponse } from 'axios';
import Axios, { Response } from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { StringLiteral } from 'typescript';
import { StackId } from 'recharts/types/util/ChartUtils';

export const PRODUCT_TYPE_DELIVERY = 0;
export const PRODUCT_TYPE_EXTENSION = 2;
export const PRODUCT_TYPE_RENTAL_DIRECT = 3;
export const PRODUCT_TYPE_RENTAL_SMS = 4;

export type OrderHistory = {
  order: Order;
};

export type Order = {
  order_id?: string;
  table_area_nr?: number;
  table_nr?: number;
  is_active?: number;
  is_complete?: number;
  completed_at?: null | string;
  child?: OrderChild[];
};

export type OrderChild = {
  confirmed_at?: string;
  delivery_tip?: string;
  room_tip: number;
  order_seq?: number;
  order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  bill_number: string;
  order_nr: null | number;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  prepared_at: null | string;
  picked_up_at: null | string;
  cancelled_at: null | string;
  cancel_description: null | string;
  detail: Product[];
  store_discount_amount?: number;
  com_discount_amount?: number;
  delivery_address?: string;
  store_name?: string;
  coupons?: Coupon[];
};

export type Product = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: '';
  product_discount: number;
  product_discount_amount: number;
  product_quantity: number;
  product_org_price: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number;
  request_message: string;
  prepared_at: string;
  cancelled_at: string;
  cancel_description: string;
  options: Option[];
  set_options: Product;
  set_prd_type_list: SetMenuGroup[];
};

export type Option = {
  option_id: number;
  option_name: string;
  option_price: number;
  option_type_id?: number;
  option_type_name?: number;
};
export type SetMenuGroup = {
  set_prd_type_id: number;
  set_prd_type_min: number;
  set_prd_type_name: string;
  set_product: SetMenu[];
};
export type SetMenu = {
  product_id: number;
  product_name: string;
  product_total_amount: number;
  product_price: number;
  options: Option[];
};

export type Coupon = {
  coupon_id: number;
  coupon_name: string;
  coupon_detail_id: number;
  com_discount_amount: number;
  store_discount_amount: number;
  used_at: string;
};

export type SetPrdType = {
  set_prd_type_id: number;
  set_prd_type_name: string;
  set_prd_type_min: number;
  set_product: SetProduct[];
};

export type SetProduct = {
  product_id: number;
  product_name: string;
  product_price: number;
  product_total_amount: number;
  options: Option[];
};

export type OrderChildType = {
  order_seq: number;
  order_status: number;
  next_order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  delivery_address: string;
  delivery_address_detail: string;
  delivery_estimated_time: number;
  delivery_prepared_time?: number;
  delivery_type: number;
  delivery_tip: number;
  room_tip: number;
  bill_number: string;
  order_nr: null;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  inquiry: string;
  created_at: string | null;
  confirmed_at: string | null;
  prepared_at: string | null;
  picked_up_at: string | null;
  completed_at: null | string;
  delivery_expected_at: null | string;
  delivery_completed_at: null | string;
  cancelled_at: string | null;
  cancel_description: string;
  hotel_name: string;
  hotel_phone_number: string;
  store_phone_number: string;
  store_discount_amount: number;
  com_discount_amount: number;
  order_category: number;
  order_check_type: number;
  customer_phone_number: string | null;
  email: string | null;
  store_address1: string | null;
  store_address2: string | null;
  request_cancel: number;
  lang: number;
  prd_discount_amount: number;
  pickup_name: string;
  delivery_score: string | null;
  food_score: string | null;

  detail: {
    product_id: number;
    product_seq: number;
    set_product_seq: number;
    product_name: string;
    is_set: number;
    has_option: number;
    product_status: number;
    product_price: number;
    product_discount_name: string;
    product_discount_amount: number;
    product_quantity: number;
    product_tax: number;
    product_tax_name: string | null;
    product_tax_rate: string;
    product_total_amount: number;
    request_id: null;
    request_message: null;
    prepared_at: string | null;
    cancelled_at: string | null;
    cancel_description: string | null;
    set_prd_type_list: SetPrdType[];
    options: Option[];
    product_org_price: number;
    product_discount: number;
  }[];
  coupons: {
    com_discount_amount: number;
    coupon_detail_id: number;
    coupon_id: number;
    coupon_name: string;
    store_discount_amount: number;
    used_at: string;
  }[];
};

export type OrderType = KnockOrderType | ThrooOrderType;
export type OrderItemType = KnockOrderItemType | ThrooOrderType;

export type KnockOrderType = {
  app_name: 'KNOCK';
  store_name: string;
  order_id: string;
  table_area_nr: number;
  table_nr: number;
  is_active: number;
  is_complete: number;
  completed_at: string | null;
  created_at: string;
  child: OrderChildType[];
  store_id: number;
  parent_store_id: number;
  payment?: paymentRealmType[];
};

export type ThrooOrderType = {
  app_name: 'THROO';
  row_num: string;
  order_sequence: string;
  store_id: number;
  order_id: number;
  order_nr: string;
  uuid: string;
  state_id: number;
  payment_state_id: number;
  type_id: number;
  dist_remaining: null;
  order_lat: string;
  order_lng: string;
  user_id: number;
  ccard_id: null;
  inquiry: string;
  user_phone_number: string;
  store_name: string;
  store_prepare_time: number;
  arrival_time: string;
  created_at: string;
  updated_at: string;
  confirmed_at: null;
  order_created_at: string;
  prepared_at: null;
  picked_up_at: null;
  cancelled_at: null;
  cancel_description: string;
  noti_type: number;
  noti_type_msg: string;
  pickup_type: number;
  pickup_speed: number;
  delivery_address: string;
  delivery_obtain_type: string;
  delivery_door_code: string;
  dist_remaining_nrm: string;
  type_code: string;
  type_name: string;
  state_color: string;
  user_full_name: string;
  license_number: string;
  order_total_quantity: number;
  order_total_amount_incl: string;
  order_total_amount_excl: string;
  order_total_amount_show: string;
  order_discount_amount: string;
  order_discount_amount_show: string;
  order_total_amount_org: string;
  order_total_amount_org_show: string;
  car_nr: string;
  car_style: string;
  arrival_in_minutes: number;
  arrival_in_minutes_show: string;
  arrival_in_seconds: number;
  arrival_norm: string;
  store_prepare_time_show: string;
  prepare_in_seconds: number;
  estimated_prepare_at_ts: number;
  noti_parking_arrival: number;
  noti_parking_prepare: number;
  noti_auto_order_cancel: number;
  noti_pos_order_cancel: number;
  noti_order_confirm: number;
  noti_order_prepared_aft: number;
  noti_order_prepared_bef: number;
  noti_concluded: number;
};

export type KnockOrderItemType = {
  app_name: 'KNOCK';
  store_name: string;
  order_id: string;
  store_id: number;
  table_area_nr: number;
  table_nr: number;
  parent_store_id: number;
  child: OrderChildType;
  payment?: paymentRealmType[];
};
export type KnockOrderLandingItemType = {
  app_name: 'KNOCK';
  store_name: string;
  order_id: string;
  store_id: number;
  table_area_nr: number;
  table_nr: number;
  parent_store_id: number;
  child: OrderChildType[];
  payment?: paymentRealmType[];
  order_seq?: number;
};

export type paymentRealmType = {
  tran_result?: boolean;
  tran_msg?: string;
  payment_van_id?: string;
  store_id?: string | number;
  order_id?: string;
  bill_number?: string;
  order_seq?: string | number;
  pay_seq?: string | number;
  van_type?: string;
  tran_type?: string;
  pay_type?: string;
  easy_type?: string;
  response_code?: string;
  amount?: number;
  vat_amount?: number;
  service_amount?: number;
  installment?: number;
  approval_no?: string;
  approval_date?: string;
  org_payment_van_id?: string;
  org_approval_no?: string;
  org_approval_date?: string;
  cancel_fg?: number;
  issuer_code?: string;
  issuer_name?: string;
  acquirer_code?: string;
  acquirer_name?: string;
  store_no?: string;
  cat_id?: string;
  balance?: string;
  response_msg?: string;
  card_no?: string;
  card_type?: string;
  tran_management_no?: string;
  tran_serial_no?: string;
  occurrence_point?: string;
  available_point?: string;
  accumulated_point?: string;
  cashback_store?: string;
  cashback_approval_no?: string;
  dcc_flag?: string;
  device_number?: string;
  key_data?: string;
  store_data?: string;
  edc_flag?: string;
  gift_amt?: string;
  biz_no?: string;
  notice?: string;
  cash_type?: string;
  cash_no?: string;
  send_server?: boolean;
  created_at?: Date;
  order_created_at?: Date;
  updated_at?: Date;
  cancelled_at?: Date;
  payment_at?: Date;
  org_payment_at?: Date;
};

export type OrderProductType = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: string;
  product_discount_amount: number;
  product_quantity: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number | null;
  request_message: string | null;
  prepared_at: string | null;
  cancelled_at: string | null;
  cancel_description: string | null;
  set_prd_type_list: SetPrdType[];
  options: Option[];
};

export type OrderStatusType = {
  store_id: number;
  parent_store_id: number;
  order_id: string;
  order_seq: number;
  order_status: number;
  delivery_estimated_time?: number;
  expected_at?: string;
  cancel_description?: string;
  table_area_nr: number;
  user_token_id: number;
  table_nr: number;
  status_changed_at: string;
};

const OrderController = {
  getHisDetail: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/order/hisDetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getHotelOrderNotCom: async (oParams: {
    hotel_id: number;
  }): Promise<{
    store: {
      store_name: string;
    };
    data: {
      order_id: string;
      bill_number: string;
      hotel_name: string;
      order_seq: number;
      created_at: string;
      delivery_address_detail: string;
      store_name: string;
      total_amount_incl: number;
      detail: string;
    }[];
  }> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/getHotelOrderNotCom';
      const response: any = await Axios.post(sUrl, oParams);

      if (response.status === 200 && response.data.ok === true) {
        return response.data.data;
      } else {
        return {
          store: {
            store_name: '',
          },
          data: [],
        };
      }
    } catch (err) {
      return {
        store: {
          store_name: '',
        },
        data: [],
      };
    }
  },

  completePickupZone: async (oParams: { order_id: string; order_seq: number }) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL +
        `/api/order/completePickupZone/${oParams.order_id}/${oParams.order_seq}`;
      const response: any = await Axios.get(sUrl);
      console.log(response);
      if (response.status === 200 && response.data.ok === true) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  },

  setOrderCancel: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/cancelForce';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주문 강제 취소 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  setOrderCancelPause: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/cancelPause';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주문 자동취소 일시정지 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  testOrder: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/test/knock';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[테스트주문 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  selfTestOrder: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/testOrder/onboardingTestOrderForSelfJoinStore';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[온보딩 셀프 테스트주문 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getPosOrderComplete: async (oParams: any) => {
    let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/getPosOrderComplete`;

    const response: any = await Axios.post(sUrl, oParams);

    if (response && response.data) {
      const oRes = response.data;
      let orderList: KnockOrderType[] = [];

      if (oRes.ok && oRes.data.length > 0) {
        orderList = oRes.data;
      }

      return orderList;
    }
  },

  getPosOrderNotComplete: async () => {
    let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/getPosOrderNotComplete`;

    const response: any = await Axios.post(sUrl);

    if (response && response.data) {
      const oRes = response.data;
      let orderList: KnockOrderType[] = [];

      if (oRes.ok && oRes.data.length > 0) {
        orderList = oRes.data;
      }

      return orderList;
    }
  },

  // status 업데이트
  updateStatus: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/updateStatus`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주문상태 업데이트 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  // 주문 상태 확인 landingpage
  getOrderByOrderId: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/getOrderByOrderId';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[landingpage 주문 상태 확인]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  requestCancel: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/requestCancel';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[landingpage 주문 취소]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  rollbackOrder: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/rollbackOrder';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[rollbackOrder 주문 취소]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  completeOrderStaff: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/completeOrderStaff';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[직원사용완료처리]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  cancelCustomer: async (order_id: string, order_seq: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/cancelCustomer`;
      const data = {
        order_id,
        order_seq,
      };

      const response: any = await Axios.post(sUrl, data);

      return response.data;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: 'ERROR [order/cancelCustomer]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  setReview: async (data: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/setReview';
      const response: AxiosResponse = await Axios.post(sUrl, data);

      return response.data;
    } catch (err: any) {
      console.error('ERROR [order/setReview] : ', err);

      return {
        ok: false,
        msg: 'ERROR [order/setReview] : ' + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default OrderController;
